function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M16.21.62H3.31A2.93 2.93 0 00.39 3.56v9.38a2.93 2.93 0 002.94 2.93h.58v2.93a.59.59 0 001 .41l3.35-3.34h7.97a2.93 2.93 0 002.93-2.93V3.56A2.93 2.93 0 0016.22.62zm1.76 12.31a1.76 1.76 0 01-1.75 1.76H8a.59.59 0 00-.42.17l-2.52 2.52v-2.1a.59.59 0 00-.58-.59H3.32a1.76 1.76 0 01-1.76-1.76V3.55A1.76 1.76 0 013.32 1.8h12.9a1.76 1.76 0 011.75 1.76v9.38zm-2.39-4.46a.6.6 0 01-.12.19L13.1 11a.59.59 0 01-.83-.83l1.35-1.34H8a1.76 1.76 0 00-1.76 1.76.59.59 0 01-1.18 0 2.93 2.93 0 012.94-2.93h5.62L12.28 6.3a.58.58 0 01.2-.95.59.59 0 01.63.12l2.35 2.35a.6.6 0 01.12.64z"
});

function SvgRequestsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestsIcon);
export default __webpack_public_path__ + "static/media/requests-icon.0efd3abb.svg";
export { ForwardRef as ReactComponent };